import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "../../services/stripe";
import StripeCheckoutForm from "./StripeCheckoutForm";

export function StripeCheckout({ clientSecret, orderId, shipmentId }) {
    return (
        <Elements
            stripe={stripePromise}
            options={{
                clientSecret,
                appearance: { theme: "stripe" },
            }}
        >
            <StripeCheckoutForm
                orderId={orderId}
                shipmentId={shipmentId}
            />
        </Elements>
    );
}